var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 2.49967C13.3049 3.04961 13.3049 3.6164 13.4167 4.16634H3.75919L10.0509 9.71801L14.2584 5.95134C14.6134 6.39051 15.0567 6.75634 15.5609 7.02217L10.06 11.948L3.33335 6.01301V15.833H16.6667V7.41634C17.2166 7.52808 17.7834 7.52808 18.3334 7.41634V16.6663C18.3334 16.8874 18.2456 17.0993 18.0893 17.2556C17.933 17.4119 17.721 17.4997 17.5 17.4997H2.50002C2.27901 17.4997 2.06704 17.4119 1.91076 17.2556C1.75448 17.0993 1.66669 16.8874 1.66669 16.6663V3.33301C1.66669 3.11199 1.75448 2.90003 1.91076 2.74375C2.06704 2.58747 2.27901 2.49967 2.50002 2.49967H13.4167ZM17.5 0.833008C17.8283 0.833008 18.1534 0.897672 18.4567 1.02331C18.76 1.14895 19.0356 1.33309 19.2678 1.56524C19.4999 1.79739 19.6841 2.07299 19.8097 2.3763C19.9354 2.67961 20 3.0047 20 3.33301C20 3.66131 19.9354 3.9864 19.8097 4.28972C19.6841 4.59303 19.4999 4.86863 19.2678 5.10077C19.0356 5.33292 18.76 5.51707 18.4567 5.64271C18.1534 5.76834 17.8283 5.83301 17.5 5.83301C16.837 5.83301 16.2011 5.56962 15.7323 5.10077C15.2634 4.63193 15 3.99605 15 3.33301C15 2.66997 15.2634 2.03408 15.7323 1.56524C16.2011 1.0964 16.837 0.833008 17.5 0.833008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEmail);
export default __webpack_public_path__ + "static/media/MyEmail.3840a5a99067fa892a82139ec7f14a70.svg";
export { ForwardRef as ReactComponent };